module.exports = __webpack_public_path__ + "media/img/logos/apple-042f3eb9160211c04ef010301b7daf55.svg";